import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import '../styles/Switch.css';

const Switch = () => {
  useEffect(() => {
    document.body.classList.add('switch-page-active');
    return () => {
      document.body.classList.remove('switch-page-active');
    };
  }, []);

  return (
    <div className="switch-page">
      <div className="switch-content">
        <div className="container">
          <div className="page-content">
            <div className="book-title">
              <h1>Switch</h1>
              <p className="switch-page-intro">
                No matter what screenwriting tool you're currently using, it's easy to switch over to Fiktion.
              </p>
              <img src="/images/switch.png" alt="Switch" className="switch-page-image" />
            </div>

            <div className="switch-reasons">
              <div className="switch-reason">
                <span>1.</span>
                <div className="flex flex-column">
                  <p className="switch-reason-title">Import .fdx and .xml files</p>
                  <p className="switch-reason-text">
                    Fiktion accepts .fdx and .xml files, and converts them in a split second, so you can carry on writing right away.
                  </p>
                </div>
              </div>

              <div className="switch-reason">
                <span>2.</span>
                <div className="flex flex-column">
                  <p className="switch-reason-title">Industry standard formatting</p>
                  <p className="switch-reason-text">
                    Fiktion delivers inch-perfect formatting that meets industry standards.
                  </p>
                </div>
              </div>

              <div className="switch-reason">
                <span>3.</span>
                <div className="flex flex-column">
                  <p className="switch-reason-title">Familiar shortcuts</p>
                  <p className="switch-reason-text">
                    Many shortcuts mirror those you already use in other tools.
                  </p>
                </div>
              </div>
              <label className="switch-additional-label">IN ADDITION TO THAT, YOU GET</label>
              <div className="switch-reason">
                <span>a.</span>
                <div className="flex flex-column">
                  <p className="switch-reason-title">A workspace for all your work</p>
                  <p className="switch-reason-text">
                    Keep all your scripts in one place, including outlines, notes, research, etc.
                  </p>
                </div>
              </div>
              <div className="switch-reason">
                <span>b.</span>
                <div className="flex flex-column">
                  <p className="switch-reason-title">Simple, beautiful and modern UI</p>
                  <p className="switch-reason-text">
                    A modernised UI that creates a richer experience when outlining, navigating and writing.
                  </p>
                </div>
              </div>
              <div className="switch-reason">
                <span>c.</span>
                <div className="flex flex-column">
                  <p className="switch-reason-title">Command Palette</p>
                  <p className="switch-reason-text">
                    A command palette that helps you navigate and do various tasks at lightning speed.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="divider"></div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Switch;
